<template>
  <div
    class="
      mt-1 flex h-[26px] w-full shrink-0 items-center justify-center
      bg-bg-base-bg4
    "
    data-test="chat-unread-messages-banner"
    data-chat-unread-separator
  >
    <span class="text-label-r-13-18 text-surf-brand-basedarkwht-def">
      {{ $t('common.unreadMessages') }}
    </span>
  </div>
</template>
